<template>
  <div class="Header">
    <div class="container-fluid">
      <div class="row brand-row">
        <!-- leftside -->
        <div class="col-lg-3">
          <a class="deunderline" href="#/">
            <div class="logo-wrapper">
              <div class="logo-con">
                <div class="white-box">
                  <img src="../assets/logo.gif" id="logo" alt="logo" />
                </div>
                <div class="white-box">
                  <div class="rent-boat">RENT BOAT</div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <!-- rightside -->
        <div class="col-lg-9 title-text">
          <strong>
            <a href="#/" class="logo-link">
              <div>Chicago River Canoe &amp; Kayak</div>
            </a>
          </strong>
          <div class="established">Since 2001</div>
        </div>
      </div>
    </div>

    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-nav>
          <b-navbar-toggle target="navbar-wrapper" class="toggle-button">
            <button class="btn btn-primary">
              <i class="fas fa-bars"></i>
              Welcome
            </button>
          </b-navbar-toggle>

          <b-collapse is-nav id="navbar-wrapper">
            <b-nav-item href="#/">Home</b-nav-item>

            <!-- Navbar dropdowns -->
            <b-nav-item-dropdown text="Locations">
              <b-dropdown-item to="Busse">
                Busse Reservoir, Elk Grove Village <br />
                <span class="nav-subtext">
                            
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="ClarkPark">
                Clark Park Boathouse, Chicago <br />
                <span class="nav-subtext">
                </span>
              
              </b-dropdown-item>
              <b-dropdown-item to="Skokie"
                >Skokie Lagoons, Winnetka <br />
                <span class="nav-subtext">
                </span>
              </b-dropdown-item>

              <b-dropdown-item to="LakeTampier"
                >Lake Tampier, Orland Park <br />
                <span class="nav-subtext">
                </span>
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item to="Pricing">Pricing</b-nav-item>
            <b-nav-item to="Events">Events</b-nav-item>
            <b-nav-item to="Groups">Groups</b-nav-item>
            <b-nav-item to="FAQ">FAQ</b-nav-item>

            <b-nav-item-dropdown text="Other" right>
              <b-dropdown-item to="Employment">Employment</b-dropdown-item>
              <b-dropdown-item to="Waiver">Parental Waiver</b-dropdown-item>
              <b-dropdown-item to="Gift">Gift Certificates</b-dropdown-item>
              <b-dropdown-item to="Used">Used Boats</b-dropdown-item>
              <b-dropdown-item to="Links">Links</b-dropdown-item>
              <!-- <b-dropdown-item to="Event">The Event</b-dropdown-item> -->
            </b-nav-item-dropdown>
            <b-nav-item to="Contact">Contact</b-nav-item>
            <!-- <b-nav-item to="Boats">Boats</b-nav-item> -->

          </b-collapse>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red {
  color: red;
}

.logo-con {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.established {
  text-align: center;
  font-size: 20px;
}
.brand-row {
  position: relative;
  min-height: 120px;
  align-items: center;
}
.Header {
  border-bottom: 5px solid #c0504d;
}
.Header >>> .navbar-dark .navbar-nav .nav-link {
  font-size: 23px;
  color: white;
  padding-bottom: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.Header >>> .bg-dark {
  background-color: transparent !important;
}
.Header >>> .navbar-nav {
  width: 100%;
  justify-content: center;
}
.logo-wrapper {
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.logo-link:hover {
  text-decoration: none;
  color: #c0504d;
}
.logo-link {
  color: white !important;
  line-height: 40px;
  font-size: 37px;
  text-align: center;
}
.logo-blk {
  color: black;
}
.rent-boat {
  color: red;
  font-size: 30px;
  line-height: 40px;
  font-weight: 600;
  border: 6px solid red;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  padding-right: 10px;
}
#logo {
  height: 100px;
  padding-left: 0px;
}
.title-text {
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 34px;
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  max-width: none;
  padding: 0 16px;
  align-items: center;
}
.logo-wrapper {
  position: relative;
  z-index: 1;
}
.Header >>> .dropdown-item:hover {
  background-color: #76923d;
}
.Header >>> .toggle-button {
  width: 200px;
  border: none;
}
@media screen and (min-width: 992px) {
  .Header >>> .navbar {
    justify-content: center;
  }
  .Header >>> .navbar-collapse {
    flex-grow: 0;
    justify-content: center;
  }
}
.white-box:nth-child(2) {
  margin-left: 20px;
}
@media screen and (max-width: 1025px) {
  .white-box:nth-child(2) {
    margin-left: 20px;
  }
}
@media screen and (max-width: 991px) {
  .brand-row {
    flex-direction: column;
    padding-bottom: 12px;
  }
  .title-text {
    position: relative;
    inset: auto;
    width: 100%;
    flex: 0 0 auto;
    padding: 0 8px;
  }
  .logo-wrapper {
    width: 100%;
  }
  .logo-wrapper a {
    justify-content: center;
  }
  .white-box:nth-child(2) {
    margin-left: 80px;
  }
}

@media screen and (max-width: 991px) {
  .logo-con {
    justify-content: center;
  }
}
@media screen and (max-width: 768px) {
  .brand-row {
    min-height: 0;
    flex-direction: row;
    flex-wrap: nowrap;
    padding-bottom: 4px;
  }
  .brand-row > .col-lg-3 {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    padding: 0;
  }
  .logo-wrapper {
    width: auto;
    margin: 0;
    padding: 4px;
  }
  .logo-con {
    width: auto;
  }
  .white-box {
    padding: 4px;
  }
  .white-box:nth-child(2) {
    display: none;
  }
  #logo {
    height: 48px;
  }
  .title-text {
    position: relative;
    inset: auto;
    width: auto;
    max-width: none;
    flex: 1 1 auto;
    padding: 0 8px;
    align-items: flex-start;
    font-size: 18px;
  }
  .logo-link {
    font-size: 20px;
    line-height: 1.15;
    text-align: left;
  }
  .established {
    font-size: 13px;
    text-align: left;
  }
  .Header >>> .navbar {
    min-height: 44px;
    padding: 2px 8px;
  }
  .Header >>> .toggle-button {
    width: auto;
    padding: 0;
  }
  .Header >>> .toggle-button .btn {
    margin: 0;
    padding: 6px 12px;
  }
  .Header >>> .navbar-dark .navbar-nav .nav-link {
    padding: 6px 12px;
    font-size: 18px;
  }
}

.router-link-active {
  background-color: rgba(255, 50, 50, 0.5);
  border-radius: 8px 8px 0px 0px;
}
.white-box {
  background: white;
  padding: 10px;
  border: 1px solid black;
}
.deunderline:hover {
  text-decoration: none;
}
.nav-subtext {
  color: red;
  font-size: 0.75rem;
}
</style>
